import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { PopUpService } from 'core/services/';
import { JwtService } from 'core/services/jwt.service';

@Component({
  selector: 'lms-simple-uploader',
  templateUrl: './simple-uploader.component.html',
  styleUrls: ['./simple-uploader.component.scss']
})
export class SimpleUploaderComponent implements OnInit {
  @Input() uploadEndPoint: string;
  @Input() uploadData: any;
  @Output() uploadFinished: EventEmitter<any> = new EventEmitter<any>();

  public apiUrl: string = environment.API_URL;
  public url;

  options: UploaderOptions;
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;

  public showSpinner = false;

  constructor(public popupService: PopUpService, public translate: TranslateService, public jwtService: JwtService) {
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {
    this.url = this.apiUrl + this.uploadEndPoint;
  }

  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
      // The selected files will be autouploaded
      this.startUpload();
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      // add file to array when added
      this.files.push(output.file);
    } else if (output.type === 'drop') {
      // eslint-disable-next-line no-empty
    } else if (output.type === 'start') {
      this.showSpinner = true;
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.files.findIndex((file) => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'done') {
      this.showSpinner = false;
      this.uploadFinished.emit(output.file && output.file.response);
    }
  }

  startUpload(): void {
    this.popupService
      .confirm({
        title: this.translate.instant('customizations.documents.upload.confirmationTitle'),
        text: this.translate.instant('customizations.documents.upload.confirmationText')
      })
      .then(() => {
        const token = this.jwtService.getApiKey();
        const event: UploadInput = {
          type: 'uploadAll',
          url: this.url,
          method: 'POST',
          data: this.uploadData,
          headers: { 'X-AUTH-TOKEN': token }
        };
        this.uploadInput.emit(event);
      })
      .catch(() => {});
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }
}
